import { useMutation, useQueryClient } from '@tanstack/react-query';

import { uploadOrganizationFile } from '@/api/v4/organization-files.api';
import { QueryKey } from '@/config/query-client';

import { companyIdState } from '../../company.state';
import { useAtomValue } from 'jotai';

export const useUploadCompanyFile = () => {
  const queryClient = useQueryClient();
  const companyId = useAtomValue(companyIdState);

  const mutation = useMutation({
    mutationFn: uploadOrganizationFile,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.CompanyFiles],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.CompanyActionsInfo],
      });
    },
    onError: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QueryKey.CompanyFiles],
        }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.CompanyActionsInfo],
        }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.LastActivities] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.LastActivitiesCount],
        }),
      ]);
    },
  });

  const uploadCompanyFile = (files: File[]) => {
    if (!companyId) return;

    return mutation.mutateAsync({ organizationId: companyId, files });
  };

  return {
    uploadCompanyFile,
    isError: mutation.isError,
  };
};
